// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.TextItem-module__font-s-10___bA0Z9 {
  font-size: 10px !important;
}

.TextItem-module__font-s-12___k7RLx {
  font-size: 12px !important;
}

.TextItem-module__font-s-13___KIvpF {
  font-size: 13px !important;
}

.TextItem-module__font-s-14___NjYPe {
  font-size: 14px !important;
}

.TextItem-module__font-s-15___vQf_F {
  font-size: 15px !important;
}

.TextItem-module__font-s-16___u_kiE {
  font-size: 16px !important;
}

.TextItem-module__font-s-18___Br7Sz {
  font-size: 18px !important;
}

.TextItem-module__font-s-20___kTBPa {
  font-size: 20px !important;
}

.TextItem-module__font-s-22___eGH8A {
  font-size: 22px !important;
}

.TextItem-module__font-s-28___dxHQE {
  font-size: 28px !important;
}

.TextItem-module__font-w-400___M5pva {
  font-weight: 400 !important;
}

.TextItem-module__font-w-500___ygUv7 {
  font-weight: 500 !important;
}

.TextItem-module__font-w-600___BPim0 {
  font-weight: 600 !important;
}

.TextItem-module__font-w-700___KM2VD {
  font-weight: 700 !important;
}

.TextItem-module__p-5___uX9T2 {
  padding: 5px !important;
}

.TextItem-module__p-12___xpV8T {
  padding: 12px !important;
}

.TextItem-module__p-16___TOS9n {
  padding: 16px !important;
}

.TextItem-module__p-30___iksIj {
  padding: 30px !important;
}

.TextItem-module__p-b-0___FOR3z {
  padding-bottom: 0 !important;
}

.TextItem-module__p-b-5___tG5wf {
  padding-bottom: 5px !important;
}

.TextItem-module__p-b-10___IZ4CD {
  padding-bottom: 10px !important;
}

.TextItem-module__p-b-12____WXAZ {
  padding-bottom: 12px !important;
}

.TextItem-module__p-b-16___LOnZR {
  padding-bottom: 16px !important;
}

.TextItem-module__p-b-18___iXsbH {
  padding-bottom: 18px !important;
}

.TextItem-module__p-b-20___QjOiR {
  padding-bottom: 20px !important;
}

.TextItem-module__p-b-25___mdyX9 {
  padding-bottom: 25px !important;
}

.TextItem-module__p-b-30___B0ChQ {
  padding-bottom: 30px !important;
}

.TextItem-module__p-b-50___a3I3y {
  padding-bottom: 50px !important;
}

.TextItem-module__p-t-0___FqCUY {
  padding-top: 0 !important;
}

.TextItem-module__p-t-12___KMPrS {
  padding-top: 12px !important;
}

.TextItem-module__p-t-16___nTUVS {
  padding-top: 16px !important;
}

.TextItem-module__p-t-18___S63I3 {
  padding-top: 18px !important;
}

.TextItem-module__p-t-20___fbOMW {
  padding-top: 20px !important;
}

.TextItem-module__p-t-30___JY7_G {
  padding-top: 30px !important;
}

.TextItem-module__p-t-40___sGgtk {
  padding-top: 40px !important;
}

.TextItem-module__p-t-50___A5d0C {
  padding-top: 50px !important;
}

.TextItem-module__p-l-20___CdfgV {
  padding-left: 20px !important;
}

.TextItem-module__p-l-30___Ij438 {
  padding-left: 30px !important;
}

.TextItem-module__p-l-40___UtTnf {
  padding-left: 40px !important;
}

.TextItem-module__p-r-16___c9mJ2 {
  padding-right: 16px !important;
}

.TextItem-module__p-r-20___L1pKl {
  padding-right: 20px !important;
}

.TextItem-module__p-r-30___ZzpVN {
  padding-right: 30px !important;
}

.TextItem-module__p-r-50___S0285 {
  padding-right: 50px !important;
}

.TextItem-module__p-r-60___v2FyM {
  padding-right: 60px !important;
}

.TextItem-module__m-b-1___gKNTp {
  margin-bottom: 1px !important;
}

.TextItem-module__m-b-2___bkJ4u {
  margin-bottom: 2px !important;
}

.TextItem-module__m-b-6___G4Awd {
  margin-bottom: 6px !important;
}

.TextItem-module__m-b-8___GB2GX {
  margin-bottom: 8px !important;
}

.TextItem-module__m-b-10___CjMZv {
  margin-bottom: 10px !important;
}

.TextItem-module__m-b-14___Mby2k {
  margin-bottom: 14px !important;
}

.TextItem-module__m-b-16___LFjKN {
  margin-bottom: 16px !important;
}

.TextItem-module__m-b-20___bGrCu {
  margin-bottom: 20px !important;
}

.TextItem-module__m-b-22___shNv7 {
  margin-bottom: 22px !important;
}

.TextItem-module__m-b-24___b85aN {
  margin-bottom: 24px !important;
}

.TextItem-module__m-b-30___hW4qC {
  margin-bottom: 30px !important;
}

.TextItem-module__m-b-32___h21qB {
  margin-bottom: 32px !important;
}

.TextItem-module__m-b-40___tpmW8 {
  margin-bottom: 40px !important;
}

.TextItem-module__m-t-2___G6GPi {
  margin-top: 2px !important;
}

.TextItem-module__m-t-3___TFxA_ {
  margin-top: 3px !important;
}

.TextItem-module__m-t-4___ngDC1 {
  margin-top: 4px !important;
}

.TextItem-module__m-t-5___I7MWl {
  margin-top: 5px !important;
}

.TextItem-module__m-t-8___mjLI8 {
  margin-top: 8px !important;
}

.TextItem-module__m-t-10___d3P1g {
  margin-top: 10px !important;
}

.TextItem-module__m-t-15___eHYu6 {
  margin-top: 15px !important;
}

.TextItem-module__m-t-16___CkrzV {
  margin-top: 16px !important;
}

.TextItem-module__m-t-20___mEUqe {
  margin-top: 20px !important;
}

.TextItem-module__m-t-22___zp_jW {
  margin-top: 22px !important;
}

.TextItem-module__m-t-30___ibHYL {
  margin-top: 30px !important;
}

.TextItem-module__m-t-32___h5WUF {
  margin-top: 32px !important;
}

.TextItem-module__m-l-auto___ZEwA2 {
  margin-left: auto !important;
}

.TextItem-module__m-l-4___CSQTI {
  margin-left: 4px !important;
}

.TextItem-module__m-l-5___ibNsb {
  margin-left: 5px !important;
}

.TextItem-module__m-l-6___ddAsb {
  margin-left: 6px !important;
}

.TextItem-module__m-l-8___yXuqp {
  margin-left: 8px !important;
}

.TextItem-module__m-l-10___V7exy {
  margin-left: 10px !important;
}

.TextItem-module__m-l-16___Gm7NH {
  margin-left: 16px !important;
}

.TextItem-module__m-l-20___v0SjQ {
  margin-left: 20px !important;
}

.TextItem-module__m-l-24___V1g36 {
  margin-left: 24px !important;
}

.TextItem-module__m-l-30___kI31F {
  margin-left: 30px !important;
}

.TextItem-module__m-l-35___DJfrW {
  margin-left: 35px !important;
}

.TextItem-module__m-l-40___KVHWR {
  margin-left: 40px !important;
}

.TextItem-module__m-r-8___hhxJA {
  margin-right: 8px !important;
}

.TextItem-module__m-r-10___i6zxz {
  margin-right: 10px !important;
}

.TextItem-module__m-r-16___emNKz {
  margin-right: 16px !important;
}

.TextItem-module__m-r-20____ve69 {
  margin-right: 20px !important;
}

.TextItem-module__m-r-24___bbpvd {
  margin-right: 24px !important;
}

.TextItem-module__m-r-30___SLsUw {
  margin-right: 30px !important;
}

.TextItem-module__m-r-40___lueJ6 {
  margin-right: 40px !important;
}

.TextItem-module__border-r-3___PRAet {
  border-radius: 3px !important;
}

.TextItem-module__border-r-4___gb_js {
  border-radius: 4px !important;
}

.TextItem-module__border-r-6___NLUxn {
  border-radius: 6px !important;
}

.TextItem-module__border-r-10___y_jej {
  border-radius: 10px !important;
}

.TextItem-module__border-r-12___crOVP {
  border-radius: 12px !important;
}

.TextItem-module__border-r-16___kv_TZ {
  border-radius: 16px !important;
}

.TextItem-module__border-r-50___ofbnH {
  border-radius: 50% !important;
}

.TextItem-module__primary-border___j739K {
  border: 1px solid rgba(91, 91, 91, 0.2);
}

.TextItem-module__primary-border-b___Anz8c {
  border-bottom: 1px solid rgba(91, 91, 91, 0.2);
}

.TextItem-module__primary-border-t___uhU61 {
  border-top: 1px solid rgba(91, 91, 91, 0.2);
}

.TextItem-module__primary-border-l___G0YMc {
  border-left: 1px solid rgba(91, 91, 91, 0.2);
}

.TextItem-module__primary-border-r___G53FV {
  border-right: 1px solid rgba(91, 91, 91, 0.2);
}

.TextItem-module__secondary-border___S_QxY {
  border: 1px solid #637768;
}

.TextItem-module__secondary-border-b___BNHL6 {
  border-bottom: 1px solid #637768;
}

.TextItem-module__secondary-border-t___wkq5O {
  border-top: 1px solid #637768;
}

.TextItem-module__secondary-border-l___X1pnn {
  border-left: 1px solid #637768;
}

.TextItem-module__secondary-border-r___FW265 {
  border-right: 1px solid #637768;
}

.TextItem-module__gap-0___OtgBG {
  gap: 0 !important;
}

.TextItem-module__gap-2___CmScb {
  gap: 2px !important;
}

.TextItem-module__gap-4___y1obh {
  gap: 4px !important;
}

.TextItem-module__gap-5___lLTQt {
  gap: 5px !important;
}

.TextItem-module__gap-6___MXu6o {
  gap: 6px !important;
}

.TextItem-module__gap-8___iXDB7 {
  gap: 8px !important;
}

.TextItem-module__gap-10___mFlTf {
  gap: 10px !important;
}

.TextItem-module__gap-12___pq19t {
  gap: 12px !important;
}

.TextItem-module__gap-14___ua4cr {
  gap: 14px !important;
}

.TextItem-module__gap-16___xec11 {
  gap: 16px !important;
}

.TextItem-module__gap-18___yRsgy {
  gap: 18px !important;
}

.TextItem-module__gap-20___CiKzL {
  gap: 20px !important;
}

.TextItem-module__gap-24___IW7x9 {
  gap: 24px !important;
}

.TextItem-module__gap-26___xgfQA {
  gap: 26px !important;
}

.TextItem-module__gap-30___adVNU {
  gap: 30px !important;
}

.TextItem-module__gap-32___fllac {
  gap: 32px !important;
}

.TextItem-module__gap-40___fbLui {
  gap: 40px !important;
}

.TextItem-module__gap-50___VRGa1 {
  gap: 50px !important;
}

.TextItem-module__flex-1___OgmST {
  flex: 1;
}

.TextItem-module__flex-none___dPUVG {
  flex: none !important;
}

.TextItem-module__flex-column___duLQT {
  display: flex;
  flex-direction: column !important;
}

.TextItem-module__flex-row___tKClT {
  display: flex;
  flex-direction: row !important;
}

.TextItem-module__vertically-centered___k8aJY {
  display: flex;
  align-items: center !important;
}

.TextItem-module__horizontally-centered___GWjCL {
  display: flex;
  justify-content: center !important;
}

.TextItem-module__horizontally-end___Ped5z {
  display: flex;
  justify-content: end !important;
}

.TextItem-module__vertically-start___kC45V {
  display: flex;
  align-items: start !important;
}

.TextItem-module__space-between___t6W_7 {
  display: flex;
  justify-content: space-between !important;
}

.TextItem-module__flex-wrap___GJoKH {
  flex-wrap: wrap !important;
}

.TextItem-module__height-100___otbHG {
  height: 100%;
}

.TextItem-module__width-50___LdMh9 {
  width: 50% !important;
}

.TextItem-module__width-100___dXsHt {
  width: 100%;
}

.TextItem-module__cursor-pointer___TecRJ {
  cursor: pointer;
}

.TextItem-module__cursor-not-allowed___fNpMT {
  cursor: not-allowed !important;
}

.TextItem-module__absolute-centered___B_VBO {
  top: 50%;
  left: 50%;
  position: absolute;
  transform: translate(-50%, -50%);
}

.TextItem-module__absolute___f7E0v {
  position: absolute;
}

.TextItem-module__relative___UnzNY {
  position: relative;
}

.TextItem-module__fixed___kZlBo {
  position: fixed;
}

.TextItem-module__visible___uwBjn {
  opacity: 1;
}

.TextItem-module__invisible___YQ25A {
  opacity: 0;
}

.TextItem-module__col-90___qRJtm {
  width: 90% !important;
}

.TextItem-module__col-auto___LaJ5X {
  width: auto !important;
}

.TextItem-module__medical-tabs___v7MlO {
  gap: 30px;
  padding: 0 !important;
  margin: 20px 40px -5px 40px;
}

.TextItem-module__medical-table-new___VPFpt {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination));
  overflow-y: scroll;
  overflow-x: hidden;
}
.TextItem-module__medical-table-new___VPFpt:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.TextItem-module__medical-table-new___VPFpt::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.TextItem-module__medical-table-new___VPFpt::-webkit-scrollbar-track {
  display: none;
}
.TextItem-module__medical-table-new___VPFpt.TextItem-module__no-pagination___gqCWu {
  height: calc(100vh - var(--tabs-navigation) - var(--patient-details-header) - var(--secondary-navigation) - var(--patient-details-footer) - var(--table-tabs));
  overflow-y: scroll;
  overflow-x: hidden;
}
.TextItem-module__medical-table-new___VPFpt.TextItem-module__no-pagination___gqCWu:hover::-webkit-scrollbar-thumb {
  background-color: rgb(125, 123, 121);
  border-radius: 10px;
}
.TextItem-module__medical-table-new___VPFpt.TextItem-module__no-pagination___gqCWu::-webkit-scrollbar {
  width: 5px;
  background-color: transparent;
}
.TextItem-module__medical-table-new___VPFpt.TextItem-module__no-pagination___gqCWu::-webkit-scrollbar-track {
  display: none;
}

.TextItem-module__medical-table-empty___y6Sis {
  padding: 14px 40px !important;
}

.TextItem-module__icon-btn___MNrmg {
  width: 22px;
  height: 22px;
  cursor: pointer;
}

.TextItem-module__search-icon___U779d {
  width: 24px;
  height: 24px;
  align-self: center;
}

.TextItem-module__disable-select___CMIIj {
  user-select: none;
}

.TextItem-module__break-word___BWR3e {
  word-break: break-word;
}

.TextItem-module__popup-clear-btn___qAT6D {
  display: flex;
  align-self: center;
  cursor: pointer;
  font-weight: 500;
  font-size: 14px;
  line-height: 150%;
  color: #f06c67;
}

.TextItem-module__scroll-m-b-20___mLUst {
  scroll-margin-bottom: 20px;
}

.TextItem-module__container___BW_8Z {
  width: 95%;
}
.TextItem-module__container___BW_8Z .TextItem-module__text___wSnVF {
  height: 20px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  font-family: var(--font-family);
  font-weight: 400;
  color: #375844;
  line-height: 150%;
  display: block;
}
.TextItem-module__container___BW_8Z .TextItem-module__addition___LO2DS {
  color: #859989;
}`, "",{"version":3,"sources":["webpack://./../common/src/styles/global/_base.scss","webpack://./src/components/table/TextItem/TextItem.module.scss","webpack://./../common/src/styles/global/_mixins.scss","webpack://./../common/src/styles/global/_fonts.scss"],"names":[],"mappings":"AAIA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,0BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADMA;EACE,2BAAA;ACHF;;ADOA;EACE,uBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,wBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,+BAAA;ACJF;;ADOA;EACE,yBAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,4BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,6BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADOA;EACE,8BAAA;ACJF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,8BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,0BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,2BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,4BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADQA;EACE,6BAAA;ACLF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,uCAAA;ACNF;;ADSA;EACE,8CAAA;ACNF;;ADSA;EACE,2CAAA;ACNF;;ADSA;EACE,4CAAA;ACNF;;ADSA;EACE,6CAAA;ACNF;;ADSA;EACE,yBAAA;ACNF;;ADSA;EACE,gCAAA;ACNF;;ADSA;EACE,6BAAA;ACNF;;ADSA;EACE,8BAAA;ACNF;;ADSA;EACE,+BAAA;ACNF;;ADUA;EACE,iBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,mBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,oBAAA;ACPF;;ADUA;EACE,OAAA;ACPF;;ADUA;EACE,qBAAA;ACPF;;ADUA;EACE,aAAA;EACA,iCAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,8BAAA;ACPF;;ADUA;EACE,aAAA;EACA,kCAAA;ACPF;;ADUA;EACE,aAAA;EACA,+BAAA;ACPF;;ADUA;EACE,aAAA;EACA,6BAAA;ACPF;;ADUA;EACE,aAAA;EACA,yCAAA;ACPF;;ADUA;EACE,0BAAA;ACPF;;ADWA;EACE,YAAA;ACRF;;ADWA;EACE,qBAAA;ACRF;;ADWA;EACE,WAAA;ACRF;;ADYA;EACE,eAAA;ACTF;;ADYA;EACE,8BAAA;ACTF;;ADaA;EACE,QAAA;EACA,SAAA;EACA,kBAAA;EACA,gCAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,kBAAA;ACVF;;ADaA;EACE,eAAA;ACVF;;ADcA;EACE,UAAA;ACXF;;ADcA;EACE,UAAA;ACXF;;ADeA;EACE,qBAAA;ACZF;;ADeA;EACE,sBAAA;ACZF;;ADgBA;EACE,SAAA;EACA,qBAAA;EACA,2BAAA;ACbF;;ADgBA;EE5lBE,wLF8lBE;EE7lBF,kBAAA;EACA,kBAAA;ADglBF;AC9kBE;EACE,oCAAA;EACA,mBAAA;ADglBJ;AC7kBE;EACE,UAAA;EACA,6BAAA;AD+kBJ;AC5kBE;EACE,aAAA;AD8kBJ;ADQE;EErmBA,8JFumBI;EEtmBJ,kBAAA;EACA,kBAAA;ADgmBF;AC9lBE;EACE,oCAAA;EACA,mBAAA;ADgmBJ;AC7lBE;EACE,UAAA;EACA,6BAAA;AD+lBJ;AC5lBE;EACE,aAAA;AD8lBJ;;ADGA;EACE,6BAAA;ACAF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,eAAA;ACDF;;ADIA;EACE,WAAA;EACA,YAAA;EACA,kBAAA;ACDF;;ADIA;EACE,iBAAA;ACDF;;ADIA;EACE,sBAAA;ACDF;;ADIA;EACE,aAAA;EACA,kBAAA;EACA,eAAA;EACA,gBAAA;EACA,eAAA;EACA,iBAAA;EACA,cAAA;ACDF;;ADIA;EACE,0BAAA;ACDF;;AA3pBA;EACE,UAAA;AA8pBF;AA5pBE;EACE,YAAA;ECFF,gBAAA;EACA,mBAAA;EACA,uBAAA;ECoBA,+BApBO;EAqBP,gBAFmD;EFhBjD,cAAA;EACA,iBAAA;EACA,cAAA;AAiqBJ;AA9pBE;EACE,cAAA;AAgqBJ","sourcesContent":["@use 'mixins';\n@use 'functions';\n\n// font\n.font-s-10 {\n  font-size: 10px !important;\n}\n\n.font-s-12 {\n  font-size: 12px !important;\n}\n\n.font-s-13 {\n  font-size: 13px !important;\n}\n\n.font-s-14 {\n  font-size: 14px !important;\n}\n\n.font-s-15 {\n  font-size: 15px !important;\n}\n\n.font-s-16 {\n  font-size: 16px !important;\n}\n\n.font-s-18 {\n  font-size: 18px !important;\n}\n\n.font-s-20 {\n  font-size: 20px !important;\n}\n\n.font-s-22 {\n  font-size: 22px !important;\n}\n\n.font-s-28 {\n  font-size: 28px !important;\n}\n\n.font-w-400 {\n  font-weight: 400 !important;\n}\n\n.font-w-500 {\n  font-weight: 500 !important;\n}\n\n.font-w-600 {\n  font-weight: 600 !important;\n}\n\n.font-w-700 {\n  font-weight: 700 !important;\n}\n\n// padding\n.p-5 {\n  padding: 5px !important;\n}\n\n.p-12 {\n  padding: 12px !important;\n}\n\n.p-16 {\n  padding: 16px !important;\n}\n\n.p-30 {\n  padding: 30px !important;\n}\n\n.p-b-0 {\n  padding-bottom: 0 !important;\n}\n\n.p-b-5 {\n  padding-bottom: 5px !important;\n}\n\n.p-b-10 {\n  padding-bottom: 10px !important;\n}\n\n.p-b-12 {\n  padding-bottom: 12px !important;\n}\n\n.p-b-16 {\n  padding-bottom: 16px !important;\n}\n\n.p-b-18 {\n  padding-bottom: 18px !important;\n}\n\n.p-b-20 {\n  padding-bottom: 20px !important;\n}\n\n.p-b-25 {\n  padding-bottom: 25px !important;\n}\n\n.p-b-30 {\n  padding-bottom: 30px !important;\n}\n\n.p-b-50 {\n  padding-bottom: 50px !important;\n}\n\n.p-t-0 {\n  padding-top: 0 !important;\n}\n\n.p-t-12 {\n  padding-top: 12px !important;\n}\n\n.p-t-16 {\n  padding-top: 16px !important;\n}\n\n.p-t-18 {\n  padding-top: 18px !important;\n}\n\n.p-t-20 {\n  padding-top: 20px !important;\n}\n\n.p-t-30 {\n  padding-top: 30px !important;\n}\n\n.p-t-40 {\n  padding-top: 40px !important;\n}\n\n.p-t-50 {\n  padding-top: 50px !important;\n}\n\n.p-l-20 {\n  padding-left: 20px !important;\n}\n\n.p-l-30 {\n  padding-left: 30px !important;\n}\n\n.p-l-40 {\n  padding-left: 40px !important;\n}\n\n.p-r-16 {\n  padding-right: 16px !important;\n}\n\n.p-r-20 {\n  padding-right: 20px !important;\n}\n\n.p-r-30 {\n  padding-right: 30px !important;\n}\n\n.p-r-50 {\n  padding-right: 50px !important;\n}\n\n.p-r-60 {\n  padding-right: 60px !important;\n}\n\n// margin\n.m-b-1 {\n  margin-bottom: 1px !important;\n}\n\n.m-b-2 {\n  margin-bottom: 2px !important;\n}\n\n.m-b-6 {\n  margin-bottom: 6px !important;\n}\n\n.m-b-8 {\n  margin-bottom: 8px !important;\n}\n\n.m-b-10 {\n  margin-bottom: 10px !important;\n}\n\n.m-b-14 {\n  margin-bottom: 14px !important;\n}\n\n.m-b-16 {\n  margin-bottom: 16px !important;\n}\n\n.m-b-20 {\n  margin-bottom: 20px !important;\n}\n\n.m-b-22 {\n  margin-bottom: 22px !important;\n}\n\n.m-b-24 {\n  margin-bottom: 24px !important;\n}\n\n.m-b-30 {\n  margin-bottom: 30px !important;\n}\n\n.m-b-32 {\n  margin-bottom: 32px !important;\n}\n\n.m-b-40 {\n  margin-bottom: 40px !important;\n}\n\n.m-t-2 {\n  margin-top: 2px !important;\n}\n\n.m-t-3 {\n  margin-top: 3px !important;\n}\n\n.m-t-4 {\n  margin-top: 4px !important;\n}\n\n.m-t-5 {\n  margin-top: 5px !important;\n}\n\n.m-t-8 {\n  margin-top: 8px !important;\n}\n\n.m-t-10 {\n  margin-top: 10px !important;\n}\n\n.m-t-15 {\n  margin-top: 15px !important;\n}\n\n.m-t-16 {\n  margin-top: 16px !important;\n}\n\n.m-t-20 {\n  margin-top: 20px !important;\n}\n\n.m-t-22 {\n  margin-top: 22px !important;\n}\n\n.m-t-30 {\n  margin-top: 30px !important;\n}\n\n.m-t-32 {\n  margin-top: 32px !important;\n}\n\n.m-l-auto {\n  margin-left: auto !important;\n}\n\n.m-l-4 {\n  margin-left: 4px !important;\n}\n\n.m-l-5 {\n  margin-left: 5px !important;\n}\n\n.m-l-6 {\n  margin-left: 6px !important;\n}\n\n.m-l-8 {\n  margin-left: 8px !important;\n}\n\n.m-l-10 {\n  margin-left: 10px !important;\n}\n\n.m-l-16 {\n  margin-left: 16px !important;\n}\n\n.m-l-20 {\n  margin-left: 20px !important;\n}\n\n.m-l-24 {\n  margin-left: 24px !important;\n}\n\n.m-l-30 {\n  margin-left: 30px !important;\n}\n\n.m-l-35 {\n  margin-left: 35px !important;\n}\n\n.m-l-40 {\n  margin-left: 40px !important;\n}\n\n.m-r-8 {\n  margin-right: 8px !important;\n}\n\n.m-r-10 {\n  margin-right: 10px !important;\n}\n\n.m-r-16 {\n  margin-right: 16px !important;\n}\n\n.m-r-20 {\n  margin-right: 20px !important;\n}\n\n.m-r-24 {\n  margin-right: 24px !important;\n}\n\n.m-r-30 {\n  margin-right: 30px !important;\n}\n\n.m-r-40 {\n  margin-right: 40px !important;\n}\n\n// border\n.border-r-3 {\n  border-radius: 3px !important;\n}\n\n.border-r-4 {\n  border-radius: 4px !important;\n}\n\n.border-r-6 {\n  border-radius: 6px !important;\n}\n\n.border-r-10 {\n  border-radius: 10px !important;\n}\n\n.border-r-12 {\n  border-radius: 12px !important;\n}\n\n.border-r-16 {\n  border-radius: 16px !important;\n}\n\n.border-r-50 {\n  border-radius: 50% !important;\n}\n\n.primary-border {\n  border: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-b {\n  border-bottom: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-t {\n  border-top: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-l {\n  border-left: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.primary-border-r {\n  border-right: 1px solid rgba(91, 91, 91, 0.2);\n}\n\n.secondary-border {\n  border: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-b {\n  border-bottom: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-t {\n  border-top: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-l {\n  border-left: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n.secondary-border-r {\n  border-right: 1px solid functions.get-color(greenNew, medium-dark);\n}\n\n// flex\n.gap-0 {\n  gap: 0 !important;\n}\n\n.gap-2 {\n  gap: 2px !important;\n}\n\n.gap-4 {\n  gap: 4px !important;\n}\n\n.gap-5 {\n  gap: 5px !important;\n}\n\n.gap-6 {\n  gap: 6px !important;\n}\n\n.gap-8 {\n  gap: 8px !important;\n}\n\n.gap-10 {\n  gap: 10px !important;\n}\n\n.gap-12 {\n  gap: 12px !important;\n}\n\n.gap-14 {\n  gap: 14px !important;\n}\n\n.gap-16 {\n  gap: 16px !important;\n}\n\n.gap-18 {\n  gap: 18px !important;\n}\n\n.gap-20 {\n  gap: 20px !important;\n}\n\n.gap-24 {\n  gap: 24px !important;\n}\n\n.gap-26 {\n  gap: 26px !important;\n}\n\n.gap-30 {\n  gap: 30px !important;\n}\n\n.gap-32 {\n  gap: 32px !important;\n}\n\n.gap-40 {\n  gap: 40px !important;\n}\n\n.gap-50 {\n  gap: 50px !important;\n}\n\n.flex-1 {\n  flex: 1;\n}\n\n.flex-none {\n  flex: none !important;\n}\n\n.flex-column {\n  display: flex;\n  flex-direction: column !important;\n}\n\n.flex-row {\n  display: flex;\n  flex-direction: row !important;\n}\n\n.vertically-centered {\n  display: flex;\n  align-items: center !important;\n}\n\n.horizontally-centered {\n  display: flex;\n  justify-content: center !important;\n}\n\n.horizontally-end {\n  display: flex;\n  justify-content: end !important;\n}\n\n.vertically-start {\n  display: flex;\n  align-items: start !important;\n}\n\n.space-between {\n  display: flex;\n  justify-content: space-between !important;\n}\n\n.flex-wrap {\n  flex-wrap: wrap !important;\n}\n\n// width and height\n.height-100 {\n  height: 100%;\n}\n\n.width-50 {\n  width: 50% !important;\n}\n\n.width-100 {\n  width: 100%;\n}\n\n// cursor\n.cursor-pointer {\n  cursor: pointer;\n}\n\n.cursor-not-allowed {\n  cursor: not-allowed !important;\n}\n\n// position\n.absolute-centered {\n  top: 50%;\n  left: 50%;\n  position: absolute;\n  transform: translate(-50%, -50%);\n}\n\n.absolute {\n  position: absolute;\n}\n\n.relative {\n  position: relative;\n}\n\n.fixed {\n  position: fixed;\n}\n\n// visibility\n.visible {\n  opacity: 1;\n}\n\n.invisible {\n  opacity: 0;\n}\n\n// layout\n.col-90 {\n  width: 90% !important;\n}\n\n.col-auto {\n  width: auto !important;\n}\n\n// medical fragments\n.medical-tabs {\n  gap: 30px;\n  padding: 0 !important;\n  margin: 20px 40px -5px 40px;\n}\n\n.medical-table-new {\n  @include mixins.verticalScroll(\n    calc(\n      100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n          --secondary-navigation\n        ) - var(--patient-details-footer) - var(--table-tabs) - var(--table-pagination)\n    )\n  );\n\n  &.no-pagination {\n    @include mixins.verticalScroll(\n      calc(\n        100vh - var(--tabs-navigation) - var(--patient-details-header) - var(\n            --secondary-navigation\n          ) - var(--patient-details-footer) - var(--table-tabs)\n      )\n    );\n  }\n}\n\n.medical-table-empty {\n  padding: 14px 40px !important;\n}\n\n//\n.icon-btn {\n  width: 22px;\n  height: 22px;\n  cursor: pointer;\n}\n\n.search-icon {\n  width: 24px;\n  height: 24px;\n  align-self: center;\n}\n\n.disable-select {\n  user-select: none;\n}\n\n.break-word {\n  word-break: break-word;\n}\n\n.popup-clear-btn {\n  display: flex;\n  align-self: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 14px;\n  line-height: 150%;\n  color: functions.get-color(redNew, medium-dark);\n}\n\n.scroll-m-b-20 {\n  scroll-margin-bottom: 20px;\n}\n","@use 'common-src/styles/global' as *;\n\n.container {\n  width: 95%;\n\n  .text {\n    height: 20px;\n    @include clipped-text;\n    @include get-font();\n    color: get-color(greenNew, dark);\n    line-height: 150%;\n    display: block;\n  }\n\n  .addition {\n    color: get-color(greenNew, medium);\n  }\n}\n","@forward 'sizes';\n@forward 'variables';\n\n@mixin clipped-text {\n  overflow: hidden;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n}\n\n@mixin verticalScroll($height) {\n  height: $height;\n  overflow-y: scroll;\n  overflow-x: hidden;\n\n  &:hover::-webkit-scrollbar-thumb {\n    background-color: rgb(125, 123, 121);\n    border-radius: 10px;\n  }\n\n  &::-webkit-scrollbar {\n    width: 5px;\n    background-color: transparent;\n  }\n\n  &::-webkit-scrollbar-track {\n    display: none;\n  }\n}\n","@use 'sass:map';\n@use 'sass:meta';\n@use 'sizes';\n\n// font families\n// TODO: rename this variable\n$roboto: var(--font-family);\n\n// functions\n@function get-font-size($font-size: null) {\n  // check font size exists\n  @if (map.has-key(sizes.$font-sizes, $font-size)) {\n    $value: map.get(sizes.$font-sizes, $font-size);\n    @if meta.type-of($value) == number {\n      // return font size\n      @return $value;\n    }\n\n    @return null;\n  }\n\n  @return null;\n}\n\n// mixins\n@mixin get-font($font-family: $roboto, $font-weight: 400, $font-size: null) {\n  font-family: $font-family;\n  font-weight: $font-weight;\n  font-size: get-font-size($font-size);\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"fontS10": `TextItem-module__font-s-10___bA0Z9`,
	"fontS12": `TextItem-module__font-s-12___k7RLx`,
	"fontS13": `TextItem-module__font-s-13___KIvpF`,
	"fontS14": `TextItem-module__font-s-14___NjYPe`,
	"fontS15": `TextItem-module__font-s-15___vQf_F`,
	"fontS16": `TextItem-module__font-s-16___u_kiE`,
	"fontS18": `TextItem-module__font-s-18___Br7Sz`,
	"fontS20": `TextItem-module__font-s-20___kTBPa`,
	"fontS22": `TextItem-module__font-s-22___eGH8A`,
	"fontS28": `TextItem-module__font-s-28___dxHQE`,
	"fontW400": `TextItem-module__font-w-400___M5pva`,
	"fontW500": `TextItem-module__font-w-500___ygUv7`,
	"fontW600": `TextItem-module__font-w-600___BPim0`,
	"fontW700": `TextItem-module__font-w-700___KM2VD`,
	"p5": `TextItem-module__p-5___uX9T2`,
	"p12": `TextItem-module__p-12___xpV8T`,
	"p16": `TextItem-module__p-16___TOS9n`,
	"p30": `TextItem-module__p-30___iksIj`,
	"pB0": `TextItem-module__p-b-0___FOR3z`,
	"pB5": `TextItem-module__p-b-5___tG5wf`,
	"pB10": `TextItem-module__p-b-10___IZ4CD`,
	"pB12": `TextItem-module__p-b-12____WXAZ`,
	"pB16": `TextItem-module__p-b-16___LOnZR`,
	"pB18": `TextItem-module__p-b-18___iXsbH`,
	"pB20": `TextItem-module__p-b-20___QjOiR`,
	"pB25": `TextItem-module__p-b-25___mdyX9`,
	"pB30": `TextItem-module__p-b-30___B0ChQ`,
	"pB50": `TextItem-module__p-b-50___a3I3y`,
	"pT0": `TextItem-module__p-t-0___FqCUY`,
	"pT12": `TextItem-module__p-t-12___KMPrS`,
	"pT16": `TextItem-module__p-t-16___nTUVS`,
	"pT18": `TextItem-module__p-t-18___S63I3`,
	"pT20": `TextItem-module__p-t-20___fbOMW`,
	"pT30": `TextItem-module__p-t-30___JY7_G`,
	"pT40": `TextItem-module__p-t-40___sGgtk`,
	"pT50": `TextItem-module__p-t-50___A5d0C`,
	"pL20": `TextItem-module__p-l-20___CdfgV`,
	"pL30": `TextItem-module__p-l-30___Ij438`,
	"pL40": `TextItem-module__p-l-40___UtTnf`,
	"pR16": `TextItem-module__p-r-16___c9mJ2`,
	"pR20": `TextItem-module__p-r-20___L1pKl`,
	"pR30": `TextItem-module__p-r-30___ZzpVN`,
	"pR50": `TextItem-module__p-r-50___S0285`,
	"pR60": `TextItem-module__p-r-60___v2FyM`,
	"mB1": `TextItem-module__m-b-1___gKNTp`,
	"mB2": `TextItem-module__m-b-2___bkJ4u`,
	"mB6": `TextItem-module__m-b-6___G4Awd`,
	"mB8": `TextItem-module__m-b-8___GB2GX`,
	"mB10": `TextItem-module__m-b-10___CjMZv`,
	"mB14": `TextItem-module__m-b-14___Mby2k`,
	"mB16": `TextItem-module__m-b-16___LFjKN`,
	"mB20": `TextItem-module__m-b-20___bGrCu`,
	"mB22": `TextItem-module__m-b-22___shNv7`,
	"mB24": `TextItem-module__m-b-24___b85aN`,
	"mB30": `TextItem-module__m-b-30___hW4qC`,
	"mB32": `TextItem-module__m-b-32___h21qB`,
	"mB40": `TextItem-module__m-b-40___tpmW8`,
	"mT2": `TextItem-module__m-t-2___G6GPi`,
	"mT3": `TextItem-module__m-t-3___TFxA_`,
	"mT4": `TextItem-module__m-t-4___ngDC1`,
	"mT5": `TextItem-module__m-t-5___I7MWl`,
	"mT8": `TextItem-module__m-t-8___mjLI8`,
	"mT10": `TextItem-module__m-t-10___d3P1g`,
	"mT15": `TextItem-module__m-t-15___eHYu6`,
	"mT16": `TextItem-module__m-t-16___CkrzV`,
	"mT20": `TextItem-module__m-t-20___mEUqe`,
	"mT22": `TextItem-module__m-t-22___zp_jW`,
	"mT30": `TextItem-module__m-t-30___ibHYL`,
	"mT32": `TextItem-module__m-t-32___h5WUF`,
	"mLAuto": `TextItem-module__m-l-auto___ZEwA2`,
	"mL4": `TextItem-module__m-l-4___CSQTI`,
	"mL5": `TextItem-module__m-l-5___ibNsb`,
	"mL6": `TextItem-module__m-l-6___ddAsb`,
	"mL8": `TextItem-module__m-l-8___yXuqp`,
	"mL10": `TextItem-module__m-l-10___V7exy`,
	"mL16": `TextItem-module__m-l-16___Gm7NH`,
	"mL20": `TextItem-module__m-l-20___v0SjQ`,
	"mL24": `TextItem-module__m-l-24___V1g36`,
	"mL30": `TextItem-module__m-l-30___kI31F`,
	"mL35": `TextItem-module__m-l-35___DJfrW`,
	"mL40": `TextItem-module__m-l-40___KVHWR`,
	"mR8": `TextItem-module__m-r-8___hhxJA`,
	"mR10": `TextItem-module__m-r-10___i6zxz`,
	"mR16": `TextItem-module__m-r-16___emNKz`,
	"mR20": `TextItem-module__m-r-20____ve69`,
	"mR24": `TextItem-module__m-r-24___bbpvd`,
	"mR30": `TextItem-module__m-r-30___SLsUw`,
	"mR40": `TextItem-module__m-r-40___lueJ6`,
	"borderR3": `TextItem-module__border-r-3___PRAet`,
	"borderR4": `TextItem-module__border-r-4___gb_js`,
	"borderR6": `TextItem-module__border-r-6___NLUxn`,
	"borderR10": `TextItem-module__border-r-10___y_jej`,
	"borderR12": `TextItem-module__border-r-12___crOVP`,
	"borderR16": `TextItem-module__border-r-16___kv_TZ`,
	"borderR50": `TextItem-module__border-r-50___ofbnH`,
	"primaryBorder": `TextItem-module__primary-border___j739K`,
	"primaryBorderB": `TextItem-module__primary-border-b___Anz8c`,
	"primaryBorderT": `TextItem-module__primary-border-t___uhU61`,
	"primaryBorderL": `TextItem-module__primary-border-l___G0YMc`,
	"primaryBorderR": `TextItem-module__primary-border-r___G53FV`,
	"secondaryBorder": `TextItem-module__secondary-border___S_QxY`,
	"secondaryBorderB": `TextItem-module__secondary-border-b___BNHL6`,
	"secondaryBorderT": `TextItem-module__secondary-border-t___wkq5O`,
	"secondaryBorderL": `TextItem-module__secondary-border-l___X1pnn`,
	"secondaryBorderR": `TextItem-module__secondary-border-r___FW265`,
	"gap0": `TextItem-module__gap-0___OtgBG`,
	"gap2": `TextItem-module__gap-2___CmScb`,
	"gap4": `TextItem-module__gap-4___y1obh`,
	"gap5": `TextItem-module__gap-5___lLTQt`,
	"gap6": `TextItem-module__gap-6___MXu6o`,
	"gap8": `TextItem-module__gap-8___iXDB7`,
	"gap10": `TextItem-module__gap-10___mFlTf`,
	"gap12": `TextItem-module__gap-12___pq19t`,
	"gap14": `TextItem-module__gap-14___ua4cr`,
	"gap16": `TextItem-module__gap-16___xec11`,
	"gap18": `TextItem-module__gap-18___yRsgy`,
	"gap20": `TextItem-module__gap-20___CiKzL`,
	"gap24": `TextItem-module__gap-24___IW7x9`,
	"gap26": `TextItem-module__gap-26___xgfQA`,
	"gap30": `TextItem-module__gap-30___adVNU`,
	"gap32": `TextItem-module__gap-32___fllac`,
	"gap40": `TextItem-module__gap-40___fbLui`,
	"gap50": `TextItem-module__gap-50___VRGa1`,
	"flex1": `TextItem-module__flex-1___OgmST`,
	"flexNone": `TextItem-module__flex-none___dPUVG`,
	"flexColumn": `TextItem-module__flex-column___duLQT`,
	"flexRow": `TextItem-module__flex-row___tKClT`,
	"verticallyCentered": `TextItem-module__vertically-centered___k8aJY`,
	"horizontallyCentered": `TextItem-module__horizontally-centered___GWjCL`,
	"horizontallyEnd": `TextItem-module__horizontally-end___Ped5z`,
	"verticallyStart": `TextItem-module__vertically-start___kC45V`,
	"spaceBetween": `TextItem-module__space-between___t6W_7`,
	"flexWrap": `TextItem-module__flex-wrap___GJoKH`,
	"height100": `TextItem-module__height-100___otbHG`,
	"width50": `TextItem-module__width-50___LdMh9`,
	"width100": `TextItem-module__width-100___dXsHt`,
	"cursorPointer": `TextItem-module__cursor-pointer___TecRJ`,
	"cursorNotAllowed": `TextItem-module__cursor-not-allowed___fNpMT`,
	"absoluteCentered": `TextItem-module__absolute-centered___B_VBO`,
	"absolute": `TextItem-module__absolute___f7E0v`,
	"relative": `TextItem-module__relative___UnzNY`,
	"fixed": `TextItem-module__fixed___kZlBo`,
	"visible": `TextItem-module__visible___uwBjn`,
	"invisible": `TextItem-module__invisible___YQ25A`,
	"col90": `TextItem-module__col-90___qRJtm`,
	"colAuto": `TextItem-module__col-auto___LaJ5X`,
	"medicalTabs": `TextItem-module__medical-tabs___v7MlO`,
	"medicalTableNew": `TextItem-module__medical-table-new___VPFpt`,
	"noPagination": `TextItem-module__no-pagination___gqCWu`,
	"medicalTableEmpty": `TextItem-module__medical-table-empty___y6Sis`,
	"iconBtn": `TextItem-module__icon-btn___MNrmg`,
	"searchIcon": `TextItem-module__search-icon___U779d`,
	"disableSelect": `TextItem-module__disable-select___CMIIj`,
	"breakWord": `TextItem-module__break-word___BWR3e`,
	"popupClearBtn": `TextItem-module__popup-clear-btn___qAT6D`,
	"scrollMB20": `TextItem-module__scroll-m-b-20___mLUst`,
	"container": `TextItem-module__container___BW_8Z`,
	"text": `TextItem-module__text___wSnVF`,
	"addition": `TextItem-module__addition___LO2DS`
};
module.exports = ___CSS_LOADER_EXPORT___;
